import React from 'react';

function GreyBanner({ text }) {
  return <div className="greyBanner fullWidthBanner">{text}</div>;
}

export default GreyBanner;
